import { gql } from 'urql';

export const GET_ORGANISATIONS = gql`
  query GetOrganisations($offset: Int, $limit: Int, $query: String) {
    organisations(offset: $offset, limit: $limit, query: $query) {
      items {
        id
        name
        brandsCount
      }
      total
    }
  }
`;

export const CREATE_ORGANISATION = gql`
  mutation CreateOrganisation($organisation: CreateOrganisationDto!) {
    createOrganisation(organisation: $organisation) {
      id
      name
    }
  }
`;

export const UPDATE_ORGANISATION = gql`
  mutation UpdateOrganisation($organisation: UpdateOrganisationDto!) {
    updateOrganisation(organisation: $organisation) {
      id
      name
    }
  }
`;

export const DELETE_ORGANISATION = gql`
  mutation DeleteOrganisation($id: Int!) {
    deleteOrganisation(id: $id) {
      id
    }
  }
`;

export const GET_ORGANISATION = gql`
  query GetOrganisation($id: Int!) {
    organisation(id: $id) {
      id
      name
    }
  }
`;

export const GET_ORGANISATION_USERS = gql`
  query GetOrganisationUsers($paginationParams: OrganisationUsersPaginationParams!) {
    organisationUsers(paginationParams: $paginationParams) {
      items {
        id
        firstName
        lastName
        email
        verified
      }
      total
    }
  }
`;
